"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
require("./Diagnostics.scss");
const Home_1 = __importDefault(require("./Home"));
const RootElement = ({ fulllength = false }) => ((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(Home_1.default, { fulllength: fulllength }) }));
exports.default = RootElement;
